const partners = ['HowNiceIs']

/**
 * Check whether partner is authorized
 * @param partnerId {string}         Id of the partner
 * @returns {boolean}                Returns true if patner is authorized
 */
export const checkPartner = (partnerId: null | string): boolean =>
  partnerId != null ? partners.includes(partnerId) : false
